module.exports = __webpack_public_path__ + "static/media/what_i_do_main.9cdfe4a8.svg";